import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import CustomDialog from '@/app/component/wrapper/custom-dialog'
import { useCampaignAudioFiles } from '@/app/module/campaigns/component/campaign-files-provider'

import AudioFileTable from './audio-file-table'

export type Props = {
  open: boolean
  selectedFilename?: string
  onClose: () => void
  onSave: (filename: string) => void
}

const AudioFileDialog: React.FC<Props> = ({ open, selectedFilename, onClose, onSave }) => {
  const files = useCampaignAudioFiles()
  const entries = React.useMemo(() => Object.entries(files || {}), [files])
  const [localSelectedFilename, setLocalSelectedFilename] = React.useState<string>(selectedFilename || '')

  React.useEffect(() => {
    if (open) {
      setLocalSelectedFilename(selectedFilename || '')
    }
  }, [open, selectedFilename])

  return (
    <CustomDialog open={open} fullWidth maxWidth="md" onClose={onClose}>
      <StyledDialogTitle>
        Select Audio File
        <IconButton onClick={onClose} aria-label="close">
          <Icon>close</Icon>
        </IconButton>
      </StyledDialogTitle>
      <DialogContent>
        {!entries.length ? (
          <Typography variant="body2" color="textSecondary">
            No audio files found
          </Typography>
        ) : (
          <AudioFileTable
            key={open ? 'open' : 'closed'}
            files={files}
            selectedFilename={localSelectedFilename}
            onSelect={setLocalSelectedFilename}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={!localSelectedFilename} variant="contained" onClick={() => onSave(localSelectedFilename)}>
          Save
        </Button>
      </DialogActions>
    </CustomDialog>
  )
}

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}))

export default AudioFileDialog
